/*
  MEDTUTORS — Cart Drawer Price Format + Quantity Hide
  Separat in theme.liquid vor </body> einbinden:
  <script src="{{ 'medtutors-drawer-prices.js' | asset_url }}" defer></script>
*/
(function () {

  function formatPriceEl(el) {
    if (!el || el._mtFmt) return;
    /* Niemals Cart-Icon oder Bubble patchen */
    if (el.closest('cart-icon, .cart-bubble, .header-actions__cart-icon, #cart-icon-bubble')) return;
    var text = (el.textContent || el.getAttribute('value') || '').trim();
    /* Regex: Ganzzahl + Dezimal + optionales € → nur Ganzzahl + sup € */
    var m = text.match(/^(\d+)[.,]\d{2}\s*€?$/) || text.match(/€?\s*(\d+)[.,]\d{2}$/);
    if (!m) return;
    el.innerHTML = m[1] + '<sup style="font-size:0.5em;vertical-align:super;font-weight:700;margin-left:1px;line-height:1;">€</sup>';
    el._mtFmt = true;
  }

  function patchDrawer() {
    var drawer = document.querySelector('.cart-drawer__dialog, cart-drawer-component dialog');
    if (!drawer) return;

    /* Einzelpreise: span mit "29.00€" */
    drawer.querySelectorAll('.cart-items__unit-price-wrapper span:not(.visually-hidden)').forEach(formatPriceEl);

    /* Zeilenpreis: text-component "58.00€" */
    drawer.querySelectorAll('text-component').forEach(formatPriceEl);

    /* Gesamtpreis in cart-totals */
    drawer.querySelectorAll('.cart-totals__total-value').forEach(formatPriceEl);

    /* Drawer-Titel: "Warenkorb" → "Buchungszusammenfassung" */
    var heading = drawer.querySelector('.cart-drawer__heading');
    if (heading) {
      var walker = document.createTreeWalker(heading, NodeFilter.SHOW_TEXT);
      var node;
      while ((node = walker.nextNode())) {
        if (node.textContent.trim() === 'Warenkorb') {
          node.textContent = 'Buchungszusammenfassung';
          break;
        }
      }
    }
  }

  /* Auf Dialog-open-Event hören (Horizon feuert diesen wenn Drawer aufgeht) */
  document.addEventListener('dialog:open', function(e) {
    if (e.target && e.target.closest('cart-drawer-component')) {
      setTimeout(patchDrawer, 50);
      setTimeout(patchDrawer, 300);
    }
  }, true);

  /* Fallback: MutationObserver auf dem Dialog-Element */
  var lastOpen = false;
  var drawerTimer;
  new MutationObserver(function() {
    var dialog = document.querySelector('cart-drawer-component dialog');
    var isOpen = dialog && dialog.hasAttribute('open');
    if (isOpen && !lastOpen) {
      /* Drawer wurde gerade geöffnet */
      clearTimeout(drawerTimer);
      drawerTimer = setTimeout(patchDrawer, 100);
      setTimeout(patchDrawer, 400);
    }
    lastOpen = !!isOpen;
  }).observe(document.body, { attributes: true, subtree: true, attributeFilter: ['open'] });

  /* Cart-Add Event (nach Hinzufügen zum Warenkorb) */
  document.addEventListener('cart:add', function() {
    setTimeout(patchDrawer, 300);
  });

  /* Initial für Cart Page */
  document.addEventListener('DOMContentLoaded', function() {
    /* Cart Page Preise */
    document.querySelectorAll(
      '.mt-cart-item-unit-price, .mt-cart-item-total, .mt-cart-summary-total, .mt-cart-carousel-price'
    ).forEach(formatPriceEl);

    /* Zwischensumme/Gesamtbetrag Zeilen */
    document.querySelectorAll('.mt-cart-totals-row span:last-child').forEach(formatPriceEl);

    patchDrawer();
  });

  setTimeout(patchDrawer, 1000);

})();

/* ── Cart State Sync: Button-Status nach Drawer-Änderung aktualisieren ── */
(function() {

  function syncCartButtons() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var cartVariants = cart.items.map(function(i) { return String(i.variant_id); });

        /* Produktseite "Jetzt buchen" Button */
        var kaufBtn = document.getElementById('mt-kurs-kaufen');
        if (kaufBtn) {
          var vid = kaufBtn.getAttribute('data-variant-id');
          if (vid && cartVariants.indexOf(vid) > -1) {
            kaufBtn.disabled = true;
            kaufBtn.textContent = '✓ Bereits gebucht';
            kaufBtn.style.background = '#6B7A90';
          } else {
            kaufBtn.disabled = false;
            kaufBtn.textContent = 'Jetzt buchen';
            kaufBtn.style.background = '';
          }
        }

        /* Kursliste "Jetzt buchen" Buttons */
        document.querySelectorAll('.mt-kl-buchen-btn').forEach(function(btn) {
          var vid = btn.getAttribute('data-variant-id');
          if (!vid) return;
          if (cartVariants.indexOf(vid) > -1) {
            btn.textContent = '✓ Bereits gebucht';
            btn.classList.add('mt-kl-btn--booked');
            btn.disabled = true;
          } else {
            btn.textContent = 'Jetzt buchen';
            btn.classList.remove('mt-kl-btn--booked');
            btn.disabled = false;
          }
        });
      })
      .catch(function() {});
  }

  /* Hört auf Shopify Cart Events (wenn Item entfernt/geändert wird) */
  document.addEventListener('cart:updated', syncCartButtons);
  document.addEventListener('cart:change', syncCartButtons);

  /* Fallback: MutationObserver auf Cart Item Count
     Wenn sich die Zahl ändert → Buttons neu prüfen */
  var lastCount = -1;
  setInterval(function() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        if (cart.item_count !== lastCount) {
          lastCount = cart.item_count;
          syncCartButtons();
        }
      }).catch(function() {});
  }, 2000); /* alle 2 Sekunden prüfen wenn Drawer offen */

  /* Initial sync */
  document.addEventListener('DOMContentLoaded', syncCartButtons);

})();